<template>
  <div class="http404-container">
    <div class="http404">
      <div class="pic-404">
        <img class="pic-404__parent" src="../assets/mistake.png">
        <img class="pic-404__child left" src="../assets/airplane.png">
        <img class="pic-404__child mid" src="../assets/airplane.png">
        <img class="pic-404__child right" src="../assets/airplane.png">
      </div>
      <div class="bullshit">
        <div class="bullshit__oops">出错啦！</div>
        <div class="bullshit__info">All rights reserved
          <a style="color:var(--mainColor)" :href="jumpURL">智慧校园</a>
        </div>
        <div class="bullshit__headline">您访问的页面不存在...</div>
        <div class="bullshit__info">请检查您输入的URL是否正确，或点击下面的按钮返回主页。</div>
        <a href="" class="bullshit__return-home">回到首页</a>
      </div>
    </div>
  </div>
</template>

<script>
const { jumpURL } = projectConfig
export default {
  name: 'Page404',
  data() {
    return {
      jumpURL
    }
  }
}
</script>

<style lang="scss" scoped>
.http404-container {
  transform: translate(-50%, -50%);
  position: absolute;
  top: 40%;
  left: 50%;
  user-select: none;
}

.http404 {
  position: relative;
  width: 1200px;
  padding: 0 50px;
  overflow: hidden;

  .pic-404 {
    position: relative;
    float: left;
    width: 600px;
    overflow: hidden;

    &__parent {
      width: 100%;
    }

    &__child {
      position: absolute;

      &.left {
        width: 80px;
        top: 17px;
        left: 220px;
        opacity: 0;
        animation: airplaneLeft 2s linear forwards 1s;
      }

      &.mid {
        width: 46px;
        top: 10px;
        left: 420px;
        opacity: 0;
        animation: airplaneMid 2s linear forwards 1.2s;
      }

      &.right {
        width: 62px;
        top: 100px;
        left: 500px;
        opacity: 0;
        animation: airplaneRight 2s linear forwards 1s;
      }

      @keyframes airplaneLeft {
        0% {
          top: 97px;
          left: 60px;
          opacity: 0;
        }

        20% {
          top: 81px;
          left: 92px;
          opacity: 1;
        }

        80% {
          top: 33px;
          left: 188px;
          opacity: 1;
        }

        100% {
          top: 17px;
          left: 220px;
          opacity: 0;
        }
      }

      @keyframes airplaneMid {
        0% {
          top: 160px;
          left: 120px;
          opacity: 0;
        }

        20% {
          top: 130px;
          left: 180px;
          opacity: 1;
        }

        70% {
          top: 40px;
          left: 360px;
          opacity: 1;
        }

        100% {
          top: 10px;
          left: 420px;
          opacity: 0;
        }
      }

      @keyframes airplaneRight {
        0% {
          top: 200px;
          left: 300px;
          opacity: 0;
        }

        20% {
          top: 180px;
          left: 340px;
          opacity: 1;
        }

        80% {
          top: 120px;
          left: 460px;
          opacity: 1;
        }

        100% {
          top: 100px;
          left: 500px;
          opacity: 0;
        }
      }
    }
  }

  .bullshit {
    position: relative;
    float: left;
    width: 300px;
    padding: 30px 0;
    overflow: hidden;

    &__oops {
      font-size: 32px;
      font-weight: bold;
      line-height: 40px;
      color: $mainColor;
      opacity: 0;
      margin-bottom: 20px;
      animation: slideUp .5s forwards;
    }

    &__headline {
      font-size: 20px;
      line-height: 24px;
      color: $titleColor;
      font-weight: bold;
      opacity: 0;
      margin-bottom: 10px;
      animation: slideUp .5s forwards .1s;
    }

    &__info {
      font-size: 13px;
      line-height: 21px;
      color: $contentColor;
      opacity: 0;
      margin-bottom: 30px;
      animation: slideUp .5s forwards .2s;
    }

    &__return-home {
      display: block;
      float: left;
      width: 110px;
      height: 36px;
      background: $mainColor;
      border-radius: 100px;
      text-align: center;
      color: #ffffff;
      opacity: 0;
      font-size: 14px;
      line-height: 36px;
      cursor: pointer;
      animation: slideUp .5s forwards .3s;
    }

    @keyframes slideUp {
      0% {
        transform: translateY(60px);
        opacity: 0;
      }

      100% {
        transform: translateY(0);
        opacity: 1;
      }
    }
  }
}
</style>
